import pjson from './../package.json';

// export const SERVER_URL = 'http://localhost:9090';
export const CLIENT_VERSION = pjson.version;
export const REACT_VERSION = pjson.dependencies.react;

export const SERVER_URL = process.env.NODE_ENV === 'production' ? "" : "http://127.0.0.1:9091";